import React from "react";
import Loading from "./../Components/Loading";
import { string } from "prop-types";
import axios from "axios";

const DESKTOP_VIEW = 0;
const TABLET_VIEW = 1;
const MOBILE_VIEW = 2;

class CategoryList extends React.PureComponent {
    constructor(props){
        super(props);

        this.state = {
            data: [],
            isLoading: true,
            showAll: false,
            isMobile: DESKTOP_VIEW
        };

        this.fetchData = this.fetchData.bind(this);
        this.showToggle = this.showToggle.bind(this);
        this.renderCategoryList = this.renderCategoryList.bind(this);
        this.handleWindowResize = this.handleWindowResize.bind(this);
    }

    componentDidMount() {
        this.fetchData();
        window.addEventListener("resize", this.handleWindowResize);
        this.handleWindowResize();
    }

    fetchData() {
        let query = `?rootCategoryId=${this.props.rootCategoryId}`;

        Promise.all([
            axios.get(`/api/categories${query}`),
            axios.get(`/api/redirections?filter=\\/categories\\/`),
        ]).then(([categoryResults, redirectionResults]) => {
            this.setState({
                data: categoryResults.data.children_data,
                redirections: redirectionResults.data,
                isLoading: false
            });
        }).catch(err =>{
            console.error(err);
        });
    }

    handleWindowResize() {
        if (window.innerWidth < 576 && this.state.isMobile != MOBILE_VIEW) {
            this.setState({ isMobile: MOBILE_VIEW });
        } else if (
            window.innerWidth >= 576 &&
            window.innerWidth < 992 &&
            this.state.isMobile != TABLET_VIEW
        ) {
            this.setState({ isMobile: TABLET_VIEW });
        } else if (
            window.innerWidth >= 992 &&
            this.state.isMobile != DESKTOP_VIEW
        ) {
            this.setState({ isMobile: DESKTOP_VIEW });
        }
    }

    showToggle() {
        this.setState({ showAll: !this.state.showAll });
    }

    renderCategoryList() {
        if (this.state.data.length > 0) {
            let list = this.state.data.map(category => {
                let url = `/categories/${category.id}`;
                let link = category.parent_id == "20" ? `/application${url}` : url;

                return (
                    <a
                        key={category.id}
                        className={`category ${this.state.isMobile === TABLET_VIEW ? "col-4" : "col-12"}`}
                        href={link}
                    >
                        {category.name}
                    </a>
                );
            });

            if (this.state.isMobile === MOBILE_VIEW && !this.state.showAll) {
                list = list.slice(0, 5);
            }
            return list;
        }
    }

    render() {
        return (
            <React.Fragment>
                <h2 className="title">
                    {this.props.title}
                </h2>
                <Loading isLoading={this.state.isLoading}>
                    <div className="categories-list row">
                        {
                            this.renderCategoryList()
                        }
                        {
                            this.state.isMobile === MOBILE_VIEW &&
                            this.state.data.length > 5 && (
                                <button
                                    className="btn btn-outline-lx btn-block"
                                    onClick={this.showToggle}
                                >
                                    {!this.state.showAll ? "Show More" : "Show Less"}
                                </button>
                            )
                        }
                    </div>
                </Loading>
            </React.Fragment>
        );
    }
}

CategoryList.defaultProps = {
    title: "Categories",
    rootCategoryId: "24"
};

CategoryList.propTypes = {
    title: string,
    rootCategoryId: string
};

export default CategoryList;
